import * as React from 'react';

import {ButtonCard} from 'shells/card/button-card';

import type {PotentialActivityEntityFragment as Participant} from 'nutshell-graphql-types';

import {appHistory} from '../../../../history';

import {ActivityRowBottomSection} from './activity-row-bottom-section';
import {ActivityRowTopSection} from './activity-row-top-section';

type Props = {
    activityId: string;
    participants: Participant[];
    name: string;
    startTime: number;
    endTime: number;
    hasExternalMeeting: boolean;
    onClick?: () => void;
};

export function ActivityRow(props: Props) {
    const handleOpenActivity = () => {
        if (props.onClick) {
            props.onClick();
        }
        appHistory.replace({
            ...appHistory.location,
            hash: `/${props.activityId}`,
            state: {modal: true},
        });
    };

    return (
        <ButtonCard
            onClick={handleOpenActivity}
            hasOffWhiteHover={true}
            isTransparent={true}
            isFullWidth={true}
        >
            <div className='flex gap-4 flex-dir-col'>
                <ActivityRowTopSection
                    participants={props.participants}
                    name={props.name}
                    hasExternalMeeting={props.hasExternalMeeting}
                />
                <ActivityRowBottomSection startTime={props.startTime} endTime={props.endTime} />
            </div>
        </ButtonCard>
    );
}
